// extracted by mini-css-extract-plugin
export default {"container":"companyInfo_container__aJX7D","content":"companyInfo_content__NGv3k","collapseContent":"companyInfo_collapseContent__dgb7b"};